import { useEffect } from 'react';

const useMenuOutsideClickToClose = (isMenuOpen, setIsMenuOpen) => {
  useEffect(() => {
    if (!isMenuOpen) return;
    function handleClickOutside(event) {
      const mobileMenu = document.querySelector('#mobileMenuDrawer');
      if (mobileMenu && !mobileMenu.contains(event.target)) {
        setIsMenuOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isMenuOpen]);
};

export default useMenuOutsideClickToClose;
